export default __webpack_public_path__ + "static/media/grupo.bd41a4bb.png";